// @flow

import * as React from 'react';

import BuildStore from 'app/stores/BuildStore';

import BuildHeaderComponent from 'app/components/build/Header';

type Props = {
  store: BuildStore,
  emptyContext: React.Node,
  emptyMessage?: React.Node,
  showPipeline?: boolean,
  showOrganization?: boolean
};

type State = {
  builds: Array<{
    id: string
  }>
};

export default class BuildsList extends React.Component<Props, State> {
  static defaultProps = {
    emptyContext: 'There are'
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      builds: this.props.store.all()
    };
  }

  componentDidMount() {
    this.props.store.on('change', this.handleChange);
  }

  componentWillUnmount() {
    this.props.store.off('change', this.handleChange);
  }

  getNoBuildsMessage() {
    const { state } = this.props.store.query;

    if (state) {
      if (state === "running") {
        return <p>{this.props.emptyContext} no running builds</p>;
      } else if (state === "scheduled") {
        return <p>{this.props.emptyContext} no scheduled builds</p>;
      }
    } else {
      if (this.props.emptyMessage) {
        return this.props.emptyMessage;
      }

      return <p>{this.props.emptyContext} no builds</p>;
    }
  }

  renderNoBuildsMessage() {
    return (
      <div className="dark-gray my1" style={{ maxWidth: '40em' }}>
        {this.getNoBuildsMessage()}
      </div>
    );
  }

  render() {
    if (this.state.builds.length === 0) {
      return this.renderNoBuildsMessage();
    }
    return (
      <div>
        {this.state.builds.map((build) => (
          <BuildHeaderComponent
            key={build.id}
            build={build}
            showProject={this.props.showPipeline}
            showOrganization={this.props.showOrganization}
          />
        ))}
      </div>
    );
  }

  handleChange = () => {
    this.setState({
      builds: this.props.store.all()
    });
  }
}
